import React from "react";
import { useQuery } from "@tanstack/react-query";
import * as S from "./template-page.styles";

/**
 * 템플릿 페이지 컴포넌트
 *
 * 이 파일을 복사해서 새 페이지를 만드세요.
 * 1. 파일명을 변경하세요 (template-page.tsx → my-page.tsx)
 * 2. 컴포넌트명을 변경하세요 (TemplatePage → MyPage)
 * 3. route.tsx에서 import 경로를 수정하세요
 * 4. index.ts에서 export명을 수정하세요
 */
export const TemplatePage: React.FC = () => {
  // 데이터 조회 예시 (필요시 사용)
  // const { data, isLoading } = useQuery({
  //   queryKey: ["key"],
  //   queryFn: () => api.getData(),
  // });

  return (
    <S.Container>
      <S.Header>
        <S.Title>페이지 제목</S.Title>
      </S.Header>

      <S.Content>
        {/* 여기에 페이지 내용을 작성 */}
        <p>페이지 내용</p>
      </S.Content>
    </S.Container>
  );
};
